import { gql } from '@apollo/client'

const NOTIFICATION_SUBSCRIPTION = gql`
  subscription onComment($input: commentSubscriber!) {
    onComment(input: $input) {
      status
      message
    }
  }
`
const CREATE_NEW_SUBSCRIPTION = gql`
  subscription getActionCaseListSubscription($input: commentSubscriber) {
    getActionCaseListSubscription(input: $input) {
      status
    }
  }
`
const CREATE_NEW_EVENTS = gql`
  subscription OnReminders($input: ReminderSubscriber) {
    onReminders(input: $input) {
      status
    }
  }
`
const MOVEAI_COMMENT_CREATED = gql`
  subscription moveAiComment($input: moveAiCommentSubscriber) {
    moveAiComment(input: $input) {
      status
    }
  }
`
const ADD_NEW_COMMENT = gql`
  subscription addAdminCommentToLite($input: addAdminCommentToLiteSubscriber) {
    addAdminCommentToLite(input: $input) {
      status
    }
  }
`;
export {
  NOTIFICATION_SUBSCRIPTION,
  CREATE_NEW_SUBSCRIPTION,
  CREATE_NEW_EVENTS,
  MOVEAI_COMMENT_CREATED,
  ADD_NEW_COMMENT,
}
